import { render } from "./MoreMenu.vue?vue&type=template&id=78f58d00&scoped=true&ts=true"
import script from "./MoreMenu.vue?vue&type=script&lang=ts"
export * from "./MoreMenu.vue?vue&type=script&lang=ts"

import "./MoreMenu.vue?vue&type=style&index=0&id=78f58d00&lang=scss&scoped=true"

import exportComponent from "/Users/TomaccioD/Documents/other/nigma-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f58d00"]])

export default __exports__